import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
/**
 * 对数组按照首字母分类
 * @param  {Array} array         要进行分类的数组
 * @param  {Function} selector   如果数组元素为对象，则需告知取哪个值进行分类。如：(obj) => obj.pinyin
 * @return {Array}
 */
function pySegSort(arr, selector) {
  var select = function select(val) {
    if (selector) return selector(val) || '#'; // 避免拼音为空的错误
    return val;
  };
  var lettersArr = 'abcdefghijklmnopqrstuvwxyz'.split('');
  var lettersMap = {};
  lettersArr.forEach(function (letter) {
    return lettersMap[letter] = true;
  });
  var sortedArr = arr.sort(function (a, b) {
    return select(a).localeCompare(select(b));
  });
  var groups = [];
  var notLetter = sortedArr.filter(function (val) {
    return !lettersMap[select(val)[0].toLowerCase()];
  });
  if (notLetter.length > 0) {
    groups.push({
      group: '#',
      values: notLetter
    });
  }
  lettersArr.forEach(function (l) {
    var result = {
      group: l,
      values: []
    };
    sortedArr.forEach(function (val) {
      if (l === select(val)[0].toLowerCase()) {
        result.values.push(val);
      }
    });
    if (result.values.length > 0) groups.push(result);
  });
  return groups;
}

/**
 * 获取 window 上的变量，获取window.a.b.c的语法糖，getWindowVar('a.b.c')
 * @param {String}
 * @returns {any}
 */
function getWindowVar(str) {
  if (typeof str !== 'string') {
    throw new TypeError('param must be string');
  }
  var arr = str.split('.') || [];
  var returned = window;
  while (arr.length) {
    var key = arr.shift();
    try {
      if (returned && key) {
        returned = returned[key];
      }
    } catch (e) {
      // 出错时忽略
    }
  }
  return returned;
}
var Common = {
  pySegSort: pySegSort,
  getWindowVar: getWindowVar
};
export default Common;